import {useMemo} from 'react'
import {useGetConsumersQuery, useGetCurrentUserQuery, useGetMetersQuery} from 'store/Store'
import {getDocumentId} from 'utils'

const useFormInvoiceLogic = ({fields, methods}) => {
    const {data: user} = useGetCurrentUserQuery()
    const userAccount = useMemo(() => user?.account, [user])
    const {watch} = methods
    const {account, consumer} = watch()

    const {data: consumers, isLoading: isLoadingConsumer} = useGetConsumersQuery(
        {account: getDocumentId(account)},
        {skip: !userAccount && !account}
    )

    const {data: meters, isLoading: isLoadingMeter} = useGetMetersQuery(
        {
            consumer: getDocumentId(consumer),
        },
        {skip: !consumer}
    )

    fields.createInvoice.items.consumer.options = consumers?.data
    fields.createInvoice.items.consumer.isLoading = isLoadingConsumer
    fields.createInvoice.items.meter.options = meters?.data
    fields.createInvoice.items.meter.isLoading = isLoadingMeter

    return {fields}
}

export default useFormInvoiceLogic
